/* eslint-disable indent */
/* eslint-disable no-unused-vars */
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import urls from "../../api/urls";
import EnrichedBagDetailsUI from "../../components/EnrichedBagDetailsUI";
function BagDetails() {
  const location = useLocation();
  const { GET_SHIPMENT_TRACKING } = urls;
  const params = new URLSearchParams(location.search);
  const awbNumber = params.get("awb") || params.get("awbNumber") || "";
  return (
    <EnrichedBagDetailsUI endpoint={GET_SHIPMENT_TRACKING} awbNumber={awbNumber} showBackArrow={true} />
  );
}

export default BagDetails;


